import React from 'react';
import Outer from 'components/outer-click';
import Component from 'components/component';

import modal from './base';

class Modal extends Component {

    render() {
        return (
            <div
                className="popup-container"
                style={{ display: 'block', overflow: 'auto' }}
            >
                <Outer on={this.props.close}>
                    <div className="popup">
                        <div className="popup-inner" style={{ position: 'relative' }}>
                            {this.props.onClose && (
                                <a
                                    href="#"
                                    className="popup__close"
                                    onClick={this.props.close}
                                // style={{top: -16}}
                                />
                            )}
                            {this.props.children}
                        </div>
                    </div>
                </Outer>
            </div>
        );
    }
}

export default modal(Modal)